export const dramas = [
  {
    id: 'wo-qizi-de-yi-qie',
    title: '我妻子的一切',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20drama%20poster%20background%20of%20a%20moody%20modern%20apartment%20window%20at%20night%20with%20deep%20navy%20blue%20tones%20and%20warm%20amber%20city%20glow%2C%20rain%20on%20glass%2C%20dramatic%20lonely%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-01&orientation=portrait',
    status: '连载',
    episodes: 12,
    director: '陈立航',
    cast: ['林晚晴', '周慕白', '苏芷', '高远'],
    firstAirDate: '2026-08-12',
    updateDate: '2026-10-08',
    genres: ['都市情感', '悬疑', '家庭'],
    synopsis: '结婚七年的沈砚在整理旧物时，意外发现妻子许知夏的日记里藏着另一个版本的过去。为了弄清真相，他开始重走妻子曾经走过的路，也一步步看清那个自己从未真正了解过的“妻子的一切”。',
    characters: [
      { name: '许知夏', actor: '林晚晴', desc: '温柔克制的杂志编辑，日记里记录着一段无人知晓的往事，习惯把所有的情绪藏进细节里。' },
      { name: '沈砚', actor: '周慕白', desc: '建筑设计师，理性而固执。当他开始怀疑妻子，才发现自己才是最不了解她的人。' },
      { name: '苏芷', actor: '苏芷', desc: '许知夏的旧日好友，开着一家小咖啡馆，是唯一知道那件事全部真相的人。' },
      { name: '高远', actor: '高远', desc: '沈砚的合伙人，看似最可靠的朋友，却在关键时刻一次次给出耐人寻味的建议。' },
    ],
    episodeList: [
      { index: 1, title: '第七年的雨季', date: '2026-08-12' },
      { index: 2, title: '日记本的夹层', date: '2026-08-19' },
      { index: 3, title: '她常去的咖啡馆', date: '2026-08-26' },
      { index: 4, title: '一张陌生的照片', date: '2026-09-02' },
      { index: 5, title: '旧同学的婚礼', date: '2026-09-09' },
      { index: 6, title: '没有寄出的信', date: '2026-09-16' },
      { index: 7, title: '雨夜里的电话', date: '2026-09-23' },
      { index: 8, title: '被删掉的合照', date: '2026-09-30' },
      { index: 9, title: '海边的那栋房子', date: '2026-10-02' },
      { index: 10, title: '许知夏的秘密', date: '2026-10-04' },
      { index: 11, title: '真相的前一秒', date: '2026-10-06' },
      { index: 12, title: '我妻子的一切', date: '2026-10-08' },
    ],
    featured: true,
    hot: 9860,
  },
  {
    id: 'wu-sheng-de-zheng-ci',
    title: '无声的证词',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20poster%20background%20of%20a%20forensic%20laboratory%20in%20cold%20blue%20light%20with%20a%20single%20warm%20desk%20lamp%2C%20glass%20slides%20and%20files%20on%20the%20table%2C%20mysterious%20tense%20mood%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-02&orientation=portrait',
    status: '连载',
    episodes: 8,
    director: '韩牧',
    cast: ['江凛', '白露', '许砚之'],
    firstAirDate: '2026-09-05',
    updateDate: '2026-10-07',
    genres: ['悬疑', '刑侦', '犯罪'],
    synopsis: '法医顾清在解剖一具无名尸时，发现死者手中握着一枚与自己童年记忆完全吻合的纽扣。随着案件层层剥开，一段被刻意掩埋的旧案重新浮出水面。',
    characters: [
      { name: '顾清', actor: '白露', desc: '冷静到近乎偏执的法医，相信尸体从不说谎。' },
      { name: '陆停舟', actor: '江凛', desc: '刑侦队长，办案雷厉风行，心里却藏着一桩未结的旧案。' },
      { name: '许砚之', actor: '许砚之', desc: '资深检察官，在情与法之间艰难权衡。' },
    ],
    episodeList: [
      { index: 1, title: '手里的纽扣', date: '2026-09-05' },
      { index: 2, title: '十年前的雨夜', date: '2026-09-12' },
      { index: 3, title: '沉默的目击者', date: '2026-09-19' },
      { index: 4, title: '被烧毁的档案', date: '2026-09-26' },
      { index: 5, title: '第二个死者', date: '2026-10-01' },
      { index: 6, title: '错位的证词', date: '2026-10-03' },
      { index: 7, title: '真凶的影子', date: '2026-10-05' },
      { index: 8, title: '无声的证词', date: '2026-10-07' },
    ],
    hot: 8120,
  },
  {
    id: 'chang-ye-jiang-jin',
    title: '长夜将尽',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20drama%20poster%20background%20of%20a%20dark%20forest%20road%20at%20midnight%20with%20distant%20warm%20car%20lights%20and%20deep%20navy%20fog%2C%20lonely%20tense%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-03&orientation=portrait',
    status: '连载',
    episodes: 6,
    director: '韦澈',
    cast: ['陆松', '温以宁', '周叙'],
    firstAirDate: '2026-09-28',
    updateDate: '2026-10-06',
    genres: ['悬疑', '推理', '年代'],
    synopsis: '一桩发生在十年前的失踪案，因为一通深夜打错的电话重新开启。当年的少年如今已是刑警，而他要找的人，似乎一直就在身边。',
    characters: [
      { name: '程野', actor: '陆松', desc: '执着办案的刑警，为了一桩旧案赌上整个职业生涯。' },
      { name: '温知', actor: '温以宁', desc: '沉默的图书管理员，掌握着被时间掩埋的关键线索。' },
      { name: '老周', actor: '周叙', desc: '小镇上的老警察，看似糊涂实则洞悉一切。' },
    ],
    episodeList: [
      { index: 1, title: '打错的电话', date: '2026-09-28' },
      { index: 2, title: '消失的自行车', date: '2026-09-30' },
      { index: 3, title: '河边的旧鞋', date: '2026-10-02' },
      { index: 4, title: '第二通电话', date: '2026-10-04' },
      { index: 5, title: '山中的空屋', date: '2026-10-05' },
      { index: 6, title: '长夜将尽', date: '2026-10-06' },
    ],
    hot: 7640,
  },
  {
    id: 'spring-late',
    title: '春日迟迟',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20healing%20drama%20poster%20background%20of%20a%20sunlit%20spring%20street%20with%20blossoms%20and%20warm%20amber%20afternoon%20light%2C%20soft%20bokeh%20petals%20in%20the%20air%2C%20gentle%20hopeful%20mood%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-04&orientation=portrait',
    status: '完结',
    episodes: 6,
    director: '顾南枝',
    cast: ['夏未', '程屿', '林知遥'],
    firstAirDate: '2026-06-10',
    updateDate: '2026-09-20',
    genres: ['都市情感', '治愈', '青春'],
    synopsis: '在城市里疲惫不堪的插画师回到故乡小镇，遇见守着旧书店的少年。整个春天，他们用一封信、一本书，慢慢把彼此从过去里打捞出来。',
    characters: [
      { name: '苏晚', actor: '夏未', desc: '从大城市逃回的插画师，习惯用画笔代替言语。' },
      { name: '陈屿', actor: '程屿', desc: '守着祖父旧书店的少年，安静却格外温暖。' },
      { name: '林知遥', actor: '林知遥', desc: '苏晚的闺蜜，永远站在她身后的人。' },
    ],
    episodeList: [
      { index: 1, title: '回到春天', date: '2026-06-10' },
      { index: 2, title: '旧书店的午后', date: '2026-06-24' },
      { index: 3, title: '没有名字的信', date: '2026-07-08' },
      { index: 4, title: '下雨的黄昏', date: '2026-07-22' },
      { index: 5, title: '迟到的告白', date: '2026-08-05' },
      { index: 6, title: '春日迟迟', date: '2026-09-20' },
    ],
    hot: 6890,
  },
  {
    id: 'gui-tu-you-ni',
    title: '归途有你',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%20background%20of%20a%20train%20station%20platform%20at%20sunset%20with%20warm%20amber%20glow%20and%20deep%20navy%20shadows%2C%20long%20empty%20rails%20and%20distant%20mountains%2C%20nostalgic%20warm%20mood%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-05&orientation=portrait',
    status: '完结',
    episodes: 6,
    director: '沈途',
    cast: ['何见山', '苏念', '老崔'],
    firstAirDate: '2026-05-18',
    updateDate: '2026-08-30',
    genres: ['家庭', '公路', '治愈'],
    synopsis: '在外漂泊多年的父亲病倒后，儿子开着一辆旧面包车带他走完最后一段归途。一路上的争执与沉默，让两代人重新认识彼此。',
    characters: [
      { name: '何见山', actor: '何见山', desc: '沉默寡言的父亲，把一辈子的倔强都藏进了沉默里。' },
      { name: '何川', actor: '苏念', desc: '在外打拼多年的儿子，与父亲之间有解不开的心结。' },
      { name: '老崔', actor: '老崔', desc: '路边修车铺的老板，见证了这对父子的和解。' },
    ],
    episodeList: [
      { index: 1, title: '一通电话', date: '2026-05-18' },
      { index: 2, title: '旧面包车', date: '2026-06-01' },
      { index: 3, title: '山路上的争吵', date: '2026-06-15' },
      { index: 4, title: '一碗面', date: '2026-06-29' },
      { index: 5, title: '海边的黄昏', date: '2026-07-13' },
      { index: 6, title: '归途有你', date: '2026-08-30' },
    ],
    hot: 6030,
  },
  {
    id: 'mi-wu-zhui-xiong',
    title: '迷雾追凶',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20drama%20poster%20background%20of%20a%20foggy%20mountain%20town%20at%20dawn%20with%20cold%20blue%20mist%20and%20warm%20window%20lights%2C%20silent%20eerie%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-06&orientation=portrait',
    status: '连载',
    episodes: 8,
    director: '罗砚',
    cast: ['段燃', '颜初', '老金'],
    firstAirDate: '2026-08-20',
    updateDate: '2026-10-05',
    genres: ['悬疑', '刑侦', '乡村'],
    synopsis: '一座终年被雾笼罩的小镇，每到大雾漫起就会有人失踪。年轻的女记者循着线索走进镇上，却发现所有失踪者都指向同一座废弃的老宅。',
    characters: [
      { name: '颜初', actor: '颜初', desc: '不肯放弃的调查记者，为查清真相只身入镇。' },
      { name: '段燃', actor: '段燃', desc: '小镇派出所的年轻民警，夹在真相与人情之间。' },
      { name: '老金', actor: '老金', desc: '守了老宅半辈子的老人，什么都不肯说。' },
    ],
    episodeList: [
      { index: 1, title: '起雾那天', date: '2026-08-20' },
      { index: 2, title: '第一个人', date: '2026-08-27' },
      { index: 3, title: '老宅的门', date: '2026-09-03' },
      { index: 4, title: '废弃的相册', date: '2026-09-10' },
      { index: 5, title: '守夜人', date: '2026-09-17' },
      { index: 6, title: '雾里来客', date: '2026-09-24' },
      { index: 7, title: '地窖之下', date: '2026-10-01' },
      { index: 8, title: '迷雾追凶', date: '2026-10-05' },
    ],
    hot: 5530,
  },
  {
    id: 'sui-yue-zhi-wei',
    title: '岁月知味',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20food%20drama%20poster%20background%20of%20a%20cozy%20old%20kitchen%20with%20steaming%20pots%20and%20warm%20amber%20lighting%2C%20hanging%20herbs%20and%20wooden%20shelves%2C%20nostalgic%20fragrant%20mood%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-07&orientation=portrait',
    status: '完结',
    episodes: 6,
    director: '方知味',
    cast: ['林小满', '周礼', '苏婆婆'],
    firstAirDate: '2026-04-12',
    updateDate: '2026-07-28',
    genres: ['美食', '家庭', '治愈'],
    synopsis: '老字号饭店的第三代传人接下濒临倒闭的店面，在一道道家常菜里，找回了家族的记忆，也尝到了岁月留下的味道。',
    characters: [
      { name: '林小满', actor: '林小满', desc: '年轻的主厨，固执地守着祖辈留下的老味道。' },
      { name: '周礼', actor: '周礼', desc: '美食评论人，一开始只想挑刺，后来留了下来。' },
      { name: '苏婆婆', actor: '苏婆婆', desc: '店里的老伙计，记得每一道菜的来历。' },
    ],
    episodeList: [
      { index: 1, title: '重新开张', date: '2026-04-12' },
      { index: 2, title: '一碗阳春面', date: '2026-04-26' },
      { index: 3, title: '留不住的客人', date: '2026-05-10' },
      { index: 4, title: '失传的配方', date: '2026-05-24' },
      { index: 5, title: '最后的晚餐', date: '2026-06-07' },
      { index: 6, title: '岁月知味', date: '2026-07-28' },
    ],
    hot: 4980,
  },
  {
    id: 'shan-hai-qing-shu',
    title: '山海情书',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20romance%20drama%20poster%20background%20of%20a%20dramatic%20coastline%20cliff%20at%20golden%20hour%20with%20deep%20blue%20sea%20and%20warm%20sunlight%20on%20the%20rocks%2C%20vast%20romantic%20mood%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-08&orientation=portrait',
    status: '连载',
    episodes: 6,
    director: '屿声',
    cast: ['沈屿', '江离', '阿海'],
    firstAirDate: '2026-09-15',
    updateDate: '2026-10-04',
    genres: ['爱情', '海岛', '成长'],
    synopsis: '海岛邮局的年轻邮差，坚持替一位已故老人送出最后一封情书。信寄到对岸时，却牵出了一段跨越四十年、从未说出口的爱意。',
    characters: [
      { name: '沈屿', actor: '沈屿', desc: '海岛邮局的邮差，最大的愿望是让每一封信都能抵达。' },
      { name: '江离', actor: '江离', desc: '从城市来的支教老师，与海岛格格不入却渐渐留下。' },
      { name: '阿海', actor: '阿海', desc: '看着邮局长大的老船工，知道很多旧事。' },
    ],
    episodeList: [
      { index: 1, title: '最后一封信', date: '2026-09-15' },
      { index: 2, title: '岛上的风', date: '2026-09-22' },
      { index: 3, title: '对岸的名字', date: '2026-09-29' },
      { index: 4, title: '四十年前', date: '2026-10-01' },
      { index: 5, title: '潮水退去', date: '2026-10-03' },
      { index: 6, title: '山海情书', date: '2026-10-04' },
    ],
    hot: 4410,
  },
  {
    id: 'xin-shang-yue-guang',
    title: '心上月光',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20youth%20drama%20poster%20background%20of%20a%20serene%20rooftop%20under%20a%20full%20moon%20with%20deep%20navy%20sky%20and%20soft%20warm%20string%20lights%2C%20city%20skyline%20below%2C%20quiet%20romantic%20mood%2C%20no%20text%2C%20no%20people%2C%20film%20photography%2C%20high%20detail%2C%20editorial%20cinematic%20composition&width=600&height=800&seq=drama-cover-09&orientation=portrait',
    status: '连载',
    episodes: 6,
    director: '白栀',
    cast: ['顾星野', '夏栀', '陈然'],
    firstAirDate: '2026-09-22',
    updateDate: '2026-10-03',
    genres: ['青春', '爱情', '校园'],
    synopsis: '高三的最后一个夏夜，两个在天台上约定要一起看月亮的人，因为一场误会走向不同的方向。多年后重逢，他们是否还能认出彼此眼里的那束光。',
    characters: [
      { name: '夏栀', actor: '夏栀', desc: '爱做梦的少女，把所有的喜欢都写进了月光里。' },
      { name: '顾星野', actor: '顾星野', desc: '沉默的少年，用最笨拙的方式守护着约定。' },
      { name: '陈然', actor: '陈然', desc: '两人的共同好友，始终是那个清醒的旁观者。' },
    ],
    episodeList: [
      { index: 1, title: '天台的月光', date: '2026-09-22' },
      { index: 2, title: '没说出口的话', date: '2026-09-26' },
      { index: 3, title: '散场的夏天', date: '2026-09-30' },
      { index: 4, title: '多年以后', date: '2026-10-01' },
      { index: 5, title: '重逢那晚', date: '2026-10-02' },
      { index: 6, title: '心上月光', date: '2026-10-03' },
    ],
    hot: 3920,
  },
];